import { LegalEntityType } from "../types/enum";

/**
 * Returns true for any legal entity that requires a super ledger.
 * Currently: SoleTrader (ordinal 1) and Hobbyist (ordinal 5).
 * Use this everywhere instead of hardcoding `=== 1`.
 */
export function legalEntityHasSuper(ordinal) {
    return (
        ordinal === LegalEntityType.SoleTrader.ordinal ||
        ordinal === LegalEntityType.Hobbyist.ordinal
    );
}

/**
 * Returns true only for SoleTrader (ordinal 1).
 * Use this where Hobbyist intentionally has different behaviour
 * (e.g. ABN is not required for Hobbyist).
 */
export function legalEntityIsSoleTrader(ordinal) {
    return ordinal === LegalEntityType.SoleTrader.ordinal;
}
